var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        staticClass: "chiped-input",
        class: _vm.dense ? "grv-input-dense" : "grv-input",
        attrs: {
          "menu-props": { contentClass: "grv-menu" },
          rules: _vm.rules,
          value: _vm.value,
          clearable: "",
          items: _vm.items,
          loading: _vm.loading,
          name: _vm.param.name,
          "item-text": "label",
          "item-value": "id",
          "search-input": _vm.search,
          multiple: _vm.multiple,
          readonly: _vm.readonly,
          "auto-select-first": "",
          dense: _vm.dense,
          "no-filter": "",
          "hide-no-data": "",
          chips: "",
          "small-chips": _vm.dense,
          "deletable-chips": !_vm.readonly,
          "append-icon": "search",
          placeholder: "Rechercher un programme"
        },
        on: {
          "update:error": function($event) {
            _vm.errored = $event
          },
          "update:searchInput": function($event) {
            _vm.search = $event
          },
          "update:search-input": function($event) {
            _vm.search = $event
          },
          "click:append": function($event) {
            _vm.explorer_show = true
          },
          change: function($event) {
            return _vm.$emit("update:value", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function() {
              return [_c("Label", { attrs: { param: _vm.param } })]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function(ref) {
              var tile = ref.tile
              var item = ref.item
              return [
                _c(
                  "v-list-tile-avatar",
                  [
                    tile.props.value
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check_box")
                        ])
                      : _c("v-icon", [_vm._v("check_box_outline_blank")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-tile-content",
                  {
                    attrs: {
                      title:
                        item.id +
                        " | " +
                        item.type_text +
                        " | " +
                        _vm.$maestro.babel_card_label(item)
                    }
                  },
                  [
                    _c("v-list-tile-title", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$maestro.babel_card_label(item)) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-sub-title",
                      { staticClass: "font-italic caption" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(item.type_text) + "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-list-tile-action", [
                  _vm._v("\n\t\t\t\t#" + _vm._s(item.id) + "\n\t\t\t")
                ])
              ]
            }
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "span",
                  {
                    staticClass: "limited-length",
                    attrs: {
                      title:
                        item.id +
                        " | " +
                        item.type_text +
                        " | " +
                        _vm.$maestro.babel_card_label(item)
                    }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(_vm.$maestro.babel_card_label(item)) +
                        " | " +
                        _vm._s(item.type_text) +
                        "\n\t\t\t"
                    )
                  ]
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } }),
      _vm._v(" "),
      _vm.explorer_show
        ? _c(
            "Babel",
            {
              attrs: {
                multiselect: false,
                toolbarTitle: "Rechercher un programme"
              },
              on: {
                close: function($event) {
                  _vm.explorer_show = false
                },
                selected: function($event) {
                  return _vm.onCardsSelected($event)
                }
              }
            },
            [
              _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                _vm._v("Babel ID(s) Select for Maestro ingester")
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c9fe3bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c9fe3bf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/babelid.vue
// module id = null
// module chunks = 